import { FormEventHandler } from 'react';
import CTA from '../MultipartForm/CTA';

const FormStepWrapper = (props: {
  content: any;
  onSubmit: FormEventHandler<HTMLFormElement>;
}) => {

  return <div>
    <CTA
      background="pink"
      heading="Let’s start your application!"
    >
      <p>
        You won’t be able to save this form once you start. We recommend you collect all of the information that you require before getting started. If you have any questions, feel free to <a href="/contact" target="_blank" rel="noopener">contact us</a> or read through our <a href="/pdf/YCF-Application-Overview-of-Questions.pdf" target="_blank" download>application questions</a> before you get started.
      </p>
    </CTA>
    <div className="page-width page-width--sm mobile-padding row middle-xs center-xs">
      <form onSubmit={props.onSubmit}>
        { props.content }
      </form>
    </div>
  </div>
};

export default FormStepWrapper;
